/**
 * wizard-map.ts — Mapa centralizado de wizards por perfil no frontend.
 *
 * Para adicionar um novo perfil com wizard:
 *   1. Adicionar entrada aqui
 *   2. Criar o componente do wizard
 *   3. Registrar a rota em App.tsx
 *
 * Espelha o wizard-profiles.ts do backend.
 */

export const WIZARD_MAP: Record<string, string> = {
  // 'ESCOLA|DIRETOR':     '/admin/wizard',
  // COORDENACAO e SECRETARIA seguem fluxo padrão (definir senha → login).
  // O wizard é exclusivo para o setup inicial da escola pelo Diretor.
  // 'ESCOLA|COORDENACAO': '/admin/wizard',
  // 'ESCOLA|SECRETARIA':  '/admin/wizard',
  // 'MUNICIPIO|GESTOR': '/municipio/wizard',
  // 'ESTADO|GESTOR':    '/estado/wizard',
};

/**
 * Retorna a rota do wizard para um perfil/cargo, ou null se não tiver wizard.
 */
export function getWizardRoute(perfil: string | null | undefined, cargo: string | null | undefined): string | null {
  if (!perfil) return null;
  return WIZARD_MAP[`${perfil}|${cargo}`] ?? null;
}

/**
 * Verifica se um perfil/cargo possui wizard configurado.
 */
export function hasWizard(perfil: string | null | undefined, cargo: string | null | undefined): boolean {
  return getWizardRoute(perfil, cargo) !== null;
}
